module.exports = __webpack_public_path__ + "static/media/italy.0359d85f.svg";